/**
 * Central access to CRA build-time environment variables.
 * REACT_APP_* values are inlined at build time — changing .env requires rebuild.
 */

function requireEnv(name) {
  const value = process.env[name];
  if (!value && process.env.NODE_ENV === 'production') {
    throw new Error(`Missing required environment variable: ${name}`);
  }
  return value || '';
}

export const API_BASE_URL = requireEnv('REACT_APP_API_URL');
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

export function getApiBaseUrl() {
  return API_BASE_URL;
}
